import React, { useState } from 'react';
import { IRegisterBadgeCommand, IRegisterBadgeFormProps } from './types';
import { IApiError } from '../../../../services';
import { Formik, Form } from 'formik';
import { FormGroup, SubmitButton, ButtonContainer } from '../../../form';
import { Button } from 'react-bootstrap';
import { InputText } from '../../../formikBindings';
import ErrorList from '../../../errorList';
import schema from './schema';
import getBadge from './getBadge';

export const RegisterBadgeForm: React.FC<IRegisterBadgeFormProps> = ({
  initialValues,
  badgeNumber,
  onSubmitted,
  onCancel,
}) => {
  const [ajaxErrors, setAjaxErrors] = useState<Array<string>>([]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values, { setSubmitting }) => {
        const command: IRegisterBadgeCommand = {
          number: badgeNumber,
          ...values,
        };

        getBadge(command)
          .then(() => {
            onSubmitted();
          })
          .catch((error: IApiError) => {
            if (error.errorNumber === 1010) {
              setAjaxErrors(['The badge has already been registered.']);
            } else {
              setAjaxErrors(error.messages);
            }
          })
          .finally(() => setSubmitting(false));
      }}
    >
      <Form>
        <ErrorList errors={ajaxErrors} />
        <FormGroup name="description" label="Description" required>
          <InputText name="description" maxLength={255} isValidIndicator />
        </FormGroup>
        <ButtonContainer>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <SubmitButton>Submit</SubmitButton>
        </ButtonContainer>
      </Form>
    </Formik>
  );
};
